import Icon from '@lib/components/Icon'
import { t } from '@/i18n'

export default function RbacError() {
  return (
    <div class="flex flex-col items-center justify-center min-h-screen py-24 text-center">
      <Icon name="error-warning-line" size={64} class="text-base-content/30 mb-4" />
      <h2 class="text-2xl font-bold mb-2">{t('app', 'Failed to load permissions')}</h2>
      <p class="text-base-content/60 mb-6">{t('app', 'Your permissions could not be loaded. Please reload the page. If the problem persists, contact your administrator.')}</p>
      <button type="button" class="btn btn-primary" onClick={() => document.location.reload()}>
        {t('app', 'Reload')}
      </button>
    </div>
  )
}
